var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geolocation-container"},[_c('button',{class:['button-geolocation', { tracking: _vm.tracking }],attrs:{"title":"Me localiser"},on:{"click":function($event){$event.preventDefault();return _vm.toggleTracking.apply(null, arguments)}}},[_c('i',{staticClass:"icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }